// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.proofOfIncome.landing.options.';

const PROOF_INCOME_LANDING_DESCRIPTION_METHOD_OPENBANKING = `${DOMAIN}openBankingDescription`,
  PROOF_INCOME_LANDING_DESCRIPTION_METHOD_TGSS = `${DOMAIN}TGSSDescription`,
  PROOF_INCOME_LANDING_TITLE_METHOD_OPENBANKING = `${DOMAIN}openBankingTitle`,
  PROOF_INCOME_LANDING_TITLE_METHOD_TGSS = `${DOMAIN}TGSSTitle`;

export {
  PROOF_INCOME_LANDING_DESCRIPTION_METHOD_OPENBANKING,
  PROOF_INCOME_LANDING_DESCRIPTION_METHOD_TGSS,
  PROOF_INCOME_LANDING_TITLE_METHOD_OPENBANKING,
  PROOF_INCOME_LANDING_TITLE_METHOD_TGSS,
};
